import { createSelector } from 'reselect'
import userTypeSelector from '../app/userTypeSelector'
import userViewSelector from '../app/userViewSelector'
import settingsSelector from '../app/settingsSelector'
import userTypes from '../../../helpers/enums/userTypes'
import settingsTypes from '../../../helpers/enums/settingsTypes'
import viewTypes from '../../../helpers/enums/views'
import { IAssetData } from '../../../helpers/data/assetData'
import { IStore } from '../../reducers/index'

const userSettingsSelector = (state: IStore) => {
	const userType = userTypeSelector(state)
	const userView = userViewSelector(state)
	const settings = settingsSelector(state)

	if (
		userType === userTypes.TEACHER &&
		settings.length &&
		state.app.isSplashComplete &&
		userView === viewTypes.SETTINGS
	) {
		return {
			type: settingsTypes.TEACHER,
			data: settings,
		}
	} else {
		return {
			type: settingsTypes.NONE,
		}
	}
}

const skinSelector = () => {
	const background: IAssetData = {
		type: 'static',
		path: 'assets/views/splash/background.jpg',
	}
	const animation: IAssetData = {
		type: 'animation',
		path: 'assets/views/splash/splash.json',
	}

	return {
		background,
		animation,
	}
}

const participationSelector = (state: IStore) => state.app.canParticipate
const sessionTypeSelector = (state: IStore) => state.app.sessionType

export default createSelector(
	skinSelector,
	userSettingsSelector,
	participationSelector,
	sessionTypeSelector,
	(skin, settings, canParticipate, sessionType) => ({
		skin,
		settings,
		canParticipate,
		sessionType,
	})
)
